<template>
  <div class="admin_messages">
    <v-card>
      <v-toolbar flat color="white">
        <v-card-title>
          <v-btn color="indigo" dark class="mb-2" rounded small @click="back"><v-icon>mdi-arrow-left-bold</v-icon></v-btn>
          <v-divider class="mx-4" inset vertical></v-divider>
          {{ $t('dashboard_notification') }}
        </v-card-title>
      </v-toolbar>
      <v-data-table :headers="headers" :items="messages"  :search="search" sort-by="name" class="elevation-1"><!--  -->
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
            <v-spacer></v-spacer>
          </v-toolbar>
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon
            medium
            color="green lighten-2"
            @click="ViewDetails(item)"
          >
            mdi-eye
          </v-icon>
        </template>
        <template v-slot:no-data>
          <v-list-item-title><b>Please Add A Message</b></v-list-item-title>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
  import {db} from '@/firebase';

  export default {
    name : "admin_messages",
    nav_title: 'Notifications',
    data: () => ({
      search: '',
      headers: [
        { text: 'Message Title', align: 'left',value: 'title'},
        { text: 'Message From', value: 'user_name'},
        { text: 'Message Length', value: 'length'},
        { text: 'Message Reply', value: 'reply'},
      ],
      messages: []
    }),
    
    firestore() {
      return {
        messages: db.collection('messages')
      }
    },

    methods: {
      back(){
        this.$router.go(-1)
      },
      
      ViewDetails() {
        /* eslint-disable */
        // Mst B a dialog 
      }
    }
  }
</script>
